<template>
  <div>
    <div class="container">
      <div class="logo"></div>
      <div class="tit"></div>
      <div class="btn" @click="goNext">进 入</div>
    </div>
  </div>
</template>

<script>
let that,token;
import { Toast, Dialog,Field } from 'vant';
export default {
  name: "Center",
  components:{
    'van-field':Field,
  },
  data () {
    return {
      isLogin:false
    }
  },
  created() {
    that=this;
    token=localStorage.getItem('token');
    if(token){
      this.getData();
    }
    /*this.test();
    console.log(111);*/
  },
  methods:{
    goNext() {
      if(this.isLogin){
        this.$router.push('/rule.html')
      }else{
        this.$router.push('/login.html')
      }
    },
    getData() {
      this.$http(that.$Global.api_base+'checkToken.php',{},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
          that.isLogin=true;
          that.goNext();
        }else{
          localStorage.removeItem('token');
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    test() {
      this.$http(that.$Global.api_base+'updataScore.php',{
        "desc": "金米修改运动积分，原积分数:987654321012，修改后积分数:987654321012",
        "job_num": "00003000",
        "mobile": 19865027875,
        "name": "黎鸿",
        "req_day": "20250630",
        "sn_no": "cee86478419f4304a425e38478e1e5b2",
        "score": 987654321012
      },'POST').then(function (response) {
        console.log(response)
        var res=response.data;
      }).catch(function (error) {
        console.log(error);
      })
    },
  },
}
</script>

<style scoped>
.container{
  background: var(--index_bg) no-repeat left bottom;
  background-size: 750rem auto;
  min-height: 1340rem;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}
.tit{
  background: var(--index_tit) no-repeat left bottom;
  background-size: 100% auto;
  width: 584rem;
  height: 320rem;
  position: absolute;
  left: 76rem;
  top: 270rem;
}
.btn{
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 600rem;
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/views/Index.vue